/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transparency = exports.Status = exports.SortOrder = exports.SessionType = exports.ScheduleStatus = exports.RecurringIntervalType = exports.LocationsLocationType = exports.LocationStatus = exports.LocationLocationType = exports.DayOfWeek = exports.Day = exports.ConferenceType = exports.CalendarType = exports.ApprovalStatus = exports.Action = void 0;
var Action;
(function (Action) {
    Action["UNDEFINED"] = "UNDEFINED";
    Action["KEEP_AT_CURRENT_LOCATION"] = "KEEP_AT_CURRENT_LOCATION";
    Action["MOVE_TO_LOCATION"] = "MOVE_TO_LOCATION";
    Action["DELETE"] = "DELETE";
})(Action = exports.Action || (exports.Action = {}));
var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["UNDEFINED"] = "UNDEFINED";
    ApprovalStatus["PENDING"] = "PENDING";
    ApprovalStatus["APPROVED"] = "APPROVED";
    ApprovalStatus["DECLINED"] = "DECLINED";
})(ApprovalStatus = exports.ApprovalStatus || (exports.ApprovalStatus = {}));
var CalendarType;
(function (CalendarType) {
    CalendarType["UNDEFINED"] = "UNDEFINED";
    CalendarType["GOOGLE"] = "GOOGLE";
    CalendarType["I_CAL"] = "I_CAL";
    CalendarType["OUTLOOK"] = "OUTLOOK";
    CalendarType["OFFICE_365"] = "OFFICE_365";
    CalendarType["MICROSOFT"] = "MICROSOFT";
    CalendarType["OTHER"] = "OTHER";
})(CalendarType = exports.CalendarType || (exports.CalendarType = {}));
var ConferenceType;
(function (ConferenceType) {
    ConferenceType["UNDEFINED"] = "UNDEFINED";
    ConferenceType["ONLINE_MEETING_PROVIDER"] = "ONLINE_MEETING_PROVIDER";
    ConferenceType["CUSTOM"] = "CUSTOM";
})(ConferenceType = exports.ConferenceType || (exports.ConferenceType = {}));
var Day;
(function (Day) {
    Day["UNDEFINED"] = "UNDEFINED";
    Day["MON"] = "MON";
    Day["TUE"] = "TUE";
    Day["WED"] = "WED";
    Day["THU"] = "THU";
    Day["FRI"] = "FRI";
    Day["SAT"] = "SAT";
    Day["SUN"] = "SUN";
})(Day = exports.Day || (exports.Day = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var LocationLocationType;
(function (LocationLocationType) {
    LocationLocationType["UNDEFINED"] = "UNDEFINED";
    LocationLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationLocationType["CUSTOM"] = "CUSTOM";
})(LocationLocationType = exports.LocationLocationType || (exports.LocationLocationType = {}));
var LocationStatus;
(function (LocationStatus) {
    LocationStatus["ACTIVE"] = "ACTIVE";
    LocationStatus["INACTIVE"] = "INACTIVE";
})(LocationStatus = exports.LocationStatus || (exports.LocationStatus = {}));
var LocationsLocationType;
(function (LocationsLocationType) {
    LocationsLocationType["UNKNOWN"] = "UNKNOWN";
    LocationsLocationType["BRANCH"] = "BRANCH";
    LocationsLocationType["OFFICES"] = "OFFICES";
    LocationsLocationType["RECEPTION"] = "RECEPTION";
    LocationsLocationType["HEADQUARTERS"] = "HEADQUARTERS";
    LocationsLocationType["INVENTORY"] = "INVENTORY";
})(LocationsLocationType = exports.LocationsLocationType || (exports.LocationsLocationType = {}));
var RecurringIntervalType;
(function (RecurringIntervalType) {
    RecurringIntervalType["UNDEFINED"] = "UNDEFINED";
    RecurringIntervalType["EVENT"] = "EVENT";
    RecurringIntervalType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    RecurringIntervalType["AVAILABILITY"] = "AVAILABILITY";
})(RecurringIntervalType = exports.RecurringIntervalType || (exports.RecurringIntervalType = {}));
var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["UNDEFINED"] = "UNDEFINED";
    ScheduleStatus["CREATED"] = "CREATED";
    ScheduleStatus["CANCELLED"] = "CANCELLED";
})(ScheduleStatus = exports.ScheduleStatus || (exports.ScheduleStatus = {}));
var SessionType;
(function (SessionType) {
    SessionType["UNDEFINED"] = "UNDEFINED";
    SessionType["EVENT"] = "EVENT";
    SessionType["WORKING_HOURS"] = "WORKING_HOURS";
    SessionType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    SessionType["AVAILABILITY"] = "AVAILABILITY";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var Status;
(function (Status) {
    Status["UNDEFINED"] = "UNDEFINED";
    Status["CONFIRMED"] = "CONFIRMED";
    Status["CANCELLED"] = "CANCELLED";
})(Status = exports.Status || (exports.Status = {}));
var Transparency;
(function (Transparency) {
    Transparency["UNDEFINED"] = "UNDEFINED";
    Transparency["FREE"] = "FREE";
    Transparency["BUSY"] = "BUSY";
})(Transparency = exports.Transparency || (exports.Transparency = {}));
//# sourceMappingURL=types.js.map